import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.app.toasts;

const getToasts = createSelector(getData, toasts => toasts);

export default getToasts;



// WEBPACK FOOTER //
// ./src/_selectors/appSelectors/getToasts.js